/* =========================================================
   PB:NEW 2026-06-04 — Hero slider video: load on interaction
   ---------------------------------------------------------
   Hero slider videos render with NO media src on the page:
   each <source> holds its URL in data-src (not src) and the
   <video> has preload="none" + a poster thumbnail. This means
   zero video bytes are fetched during initial page load.

   On the FIRST user interaction anywhere on the page
   (scroll, mousedown, touchstart, keydown) we:
     1. Copy each <source data-src> -> src.
     2. Call video.load() so the browser picks up the sources.
     3. Call video.play() (muted/looped autoplay) — honoring
        prefers-reduced-motion (videos stay paused).

   Runs once; listeners are bound with { once: true } and the
   `loaded` guard prevents double activation.
   ========================================================= */
(function () {
  if (window.PBHeroVideoInteraction) return; // singleton

  var loaded = false;

  var prefersReducedMotion =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function loadVideos() {
    if (loaded) return;
    loaded = true;

    var videos = document.querySelectorAll('video[data-pb-interaction-video]');

    Array.prototype.forEach.call(videos, function (video) {
      var sources = video.querySelectorAll('source[data-src]');
      Array.prototype.forEach.call(sources, function (source) {
        source.src = source.getAttribute('data-src');
        source.removeAttribute('data-src');
      });

      // Bump preload now that real sources exist, then (re)load them.
      video.setAttribute('preload', 'auto');
      try { video.load(); } catch (e) {}

      if (!prefersReducedMotion) {
        video.muted = true; // autoplay only allowed when muted
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }
    });
  }

  var userEvents = ['scroll', 'mousedown', 'touchstart', 'keydown'];

  userEvents.forEach(function (evt) {
    window.addEventListener(evt, loadVideos, { once: true, passive: true });
  });

  // Expose for sections that render videos client-side after a mutation.
  window.PBHeroVideoInteraction = { load: loadVideos };
})();
